import { StandardAPIRequest } from 'app/types/api'
import { User } from 'app/types/authorization'
import { SETTINGS } from 'app/utils/settings'

const authorized = async (authorization?: string): Promise<User | null> => {
  if (!authorization) {
    return null
  }
  var headers: HeadersInit = {
    'Content-Type': 'application/json',
  }
  if (authorization) {
    headers['Authorization'] = `Bearer ${authorization}`
  }
  try {
    const authorizedRes = await fetch(
      `${SETTINGS.API_URL}/user/authentication`,
      {
        headers,
        method: 'GET',
      }
    )
    const user: StandardAPIRequest<User> = await authorizedRes.json()
    if (user.error) {
      throw Error(user.error.message)
    }
    if (user.data === null) {
      return null
    }
    return user.data
  } catch (error) {
    console.log(error)
    return null
  }
}

export { authorized }
